import React, { FC } from 'react';
import HyperLink from '../common/HyperLink';

const PRQuantityDisplay: FC<any> = ({ quantity, stockLocationId, partId }): React.ReactElement => {
	return (
		<div>
			{quantity ? (
				<HyperLink
					text={quantity}
					newTabPath={`/supplier/purchaseRequests/overview/requests?stockLocationIds=${stockLocationId}&partIds=${partId}&statuses=${encodeURIComponent(
						'requested,approved'
					)}`}
				/>
			) : (
				0
			)}
		</div>
	);
};

export default PRQuantityDisplay;
